import { Product2, Per } from 'ep-bt-field-agent-proxy';
import { CompetitorPricing } from '../models/competitor-pricing.model';

export class CompetitorPriceLine {

    constructor(competitorPricing: CompetitorPricing, ourProduct: Product2, qtyType: any) {
        this.SetLineNumber(competitorPricing.Lines.length + 1);
        this.competitorPricing = competitorPricing;
        this.competitorID = competitorPricing.customer.customerId;
        this.ourProduct = ourProduct;
        this.ourSellPrice = ourProduct.standardSellPrice;
        this.ourSellPer = ourProduct.sellPer;
        this.competitorSellPrice = 0.0;
        this.competitorSellPer = ourProduct.sellPer;
    }

    competitorPricing?: CompetitorPricing | undefined;
    competitorID?: number | undefined;
    ourProduct?: Product2 | undefined;
    ourSellPrice?: number | undefined;
    ourSellPer?: Per | undefined;
    competitorSellPrice?: number | undefined;
    competitorSellPer?: Per | undefined;
    sellPer?: Per | undefined;
    competitorSellPerID?: number | undefined;
    competitorProductCode?: string | undefined;
    competitorProductDescription?: string | undefined;
    competitorProductSellPrice?: string | undefined;
    dateTimelastUpdated?: Date | undefined;
    notes?: string | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    adding?: boolean | undefined;
    lineNumber?: number | undefined;

    public Adding: boolean;

    public SetLineNumber(lineNumber: number) {
        this.lineNumber = lineNumber;
    }
    // public get AddressID(): number {
    //     return this.competitorPricing.selectedAddress.AddressId;
    // }

}

